import { render, staticRenderFns } from "./SubscriptionGratification.vue?vue&type=template&id=67af12c0&scoped=true&"
import script from "./SubscriptionGratification.vue?vue&type=script&lang=js&"
export * from "./SubscriptionGratification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af12c0",
  null
  
)

export default component.exports